type ModelTableApiItem = {
  placa?: string;
  chassi?: string;
  Chassi?: string;
  numeroSerie?: string;
  NumeroSerie?: string;
  marca?: string;
  modelo?: string;
  anoModelo?: string;
  anoFabricacao?: string;
  cor?: string;
  regiao?: string;
  kmAtual?: string | null;
};

type ModelTableApiResponse = {
  listagem?: ModelTableApiItem[];
  totalPaginas?: number;
  totalRegistros?: number;
};

type MappedModelTableItem = {
  plate?: string;
  chassis: string;
  serialNumber: string;
  brand?: string;
  model?: string;
  yearModel?: string;
  yearFabrication?: string;
  color?: string;
  region?: string;
  km?: string | null;
};

export type MappedModelTableData = {
  itens: MappedModelTableItem[];
  pageCount?: number;
  rows?: number;
};

const pickSerialNumber = (dto: ModelTableApiItem) =>
  dto.numeroSerie ?? dto.NumeroSerie ?? '-';

export const mapModelTableApiResponse = (
  response?: ModelTableApiResponse | null,
): MappedModelTableData => ({
  itens: (response?.listagem ?? []).map(dto => ({
    plate: dto.placa,
    chassis: dto.chassi ?? dto.Chassi ?? '-',
    serialNumber: pickSerialNumber(dto),
    brand: dto.marca,
    model: dto.modelo,
    yearModel: dto.anoModelo,
    yearFabrication: dto.anoFabricacao,
    color: dto.cor,
    region: dto.regiao,
    km: dto.kmAtual,
  })),
  pageCount: response?.totalPaginas,
  rows: response?.totalRegistros,
});

const isMissingSerialNumber = (value: unknown) =>
  value === undefined || value === null || value === '' || value === '-';

/** Re-applies serial number mapping on already transformed table rows. */
export const ensureModelTableSerialNumbers = <
  T extends { itens?: Record<string, unknown>[] },
>(
  tableData?: T | null,
): T | null | undefined => {
  if (!tableData?.itens?.length) return tableData;

  return {
    ...tableData,
    itens: tableData.itens.map(item => {
      const serialNumber = isMissingSerialNumber(item.serialNumber)
        ? item.numeroSerie ?? item.NumeroSerie ?? '-'
        : item.serialNumber;

      return {
        ...item,
        serialNumber,
      };
    }),
  };
};
